/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Gu13Inputs */

const en__field_enum_csjensblank_gu13 = /** @type {(inputs: _Field_Enum_Csjensblank_Gu13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goethe-Universität Frankfurt`)
};

const de__field_enum_csjensblank_gu13 = /** @type {(inputs: _Field_Enum_Csjensblank_Gu13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Goethe-Universität Frankfurt`)
};

/**
* | output |
* | --- |
* | "Goethe-Universität Frankfurt" |
*
* @param {_Field_Enum_Csjensblank_Gu13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_gu13 = /** @type {((inputs?: _Field_Enum_Csjensblank_Gu13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Gu13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_gu13(inputs)
	return de__field_enum_csjensblank_gu13(inputs)
});
export { _field_enum_csjensblank_gu13 as "_field_enum_CSJENSBLANK_GU" }